import React from "react";

import Form from "./form";
import { Modal, Typography, Button } from "antd";
import {
  CloseOutlined,
  CheckOutlined,
  AddOutlined,
  EditOutlined,
} from "@material-ui/icons";

class PopUpForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      data: {},
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialData !== nextProps.initialData) {
      console.log("NEW INITIAL DATA");
      if (
        nextProps.initialData &&
        Object.keys(nextProps.initialData).length >= 0
      ) {
        this.setState({ data: nextProps.initialData });
      }
    }
  }

  onChange(data) {
    console.log("changed data", data);
    this.setState({ data });
  }

  render() {
    // console.log("PROPS",this.props)
    let action = this.props.forCreate ? "Add" : "Update";
    let icon = this.props.forCreate ? <AddOutlined /> : <EditOutlined />;
    const show_title_only = this.props.show_title_only;
    if (show_title_only) {
      icon = null;
      action = "";
    }
    // console.log("schema is ",this.props.fields)
    return (
      <Modal
        centered
        dimmer="blurring"
        width={this.props.width}
        // size='small'
        visible={this.props.open}
        destroyOnClose
        onCancel={() => {
          this.setState({ submitted: false, data: {} });
          this.props.onClose();
        }}
        footer={[
          <Button
            key="cancel"
            type="danger"
            disabled={this.props.networkState.fetching}
            onClick={() => {
              this.setState({ submitted: false, data: {} });
              this.props.onClose();
            }}
          >
            {/* <CloseOutlined type='close'/> */}
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={this.props.networkState.fetching}
            loading={this.props.networkState.fetching}
            onClick={() => {
              this.setState({ submitted: true });
              typeof this.props.onSubmit === "function" &&
                this.props.onSubmit(this.state.data);
            }}
          >
            {/* <CheckOutlined type='check' /> */}
            {this.props.okText || "Submit"}
            {/* Submit */}
          </Button>,
        ]}
      >
        <Typography.Title
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          level={2}
        >
          {icon} &nbsp; {`${action} ${this.props.title}`}
        </Typography.Title>
        {this.props.top}
        {/* {JSON.stringify(this.props.fields)} */}
        {/* <Header icon={icon} content={`${action} ${this.props.title}`}/> */}
        <Form
          forCreate={this.props.forCreate}
          initialData={this.props.initialData}
          parentData={this.props.initialData}
          submitted={this.state.submitted}
          stringyfy={this.props.stringyfy}
          onChange={this.onChange}
          fields={this.props.fields}
          submitting={this.props.networkState.fetching}
          errorMessage={this.props.networkState.error_message}
          validationErrors={this.props.networkState.validation_errors}
        />
        {this.props.bottom}
      </Modal>
    );
  }
}

export { PopUpForm };
